export interface ResponseState {
  responses: any[];
  filteredResponses: any[];
  searchQuery: string;
  isLoading: boolean;
  isAddingAction: boolean;
  error: string | null;
  lastUpdated: number | null;
  selectedResponse: any | null;
  selectedChild: any | null;
  disableAddMessage: boolean;
}

export const initialResponseState: ResponseState = {
  responses: [],
  filteredResponses: [],
  searchQuery: '',
  isLoading: false,
  isAddingAction: false,
  error: null,
  lastUpdated: null,
  selectedResponse: null,
  selectedChild: null,disableAddMessage: false,
};
